import React from 'react';

import Header from '../../common/Header';

import { BlockersSection } from './components/BlockersSection';
import { WelcomeSection } from './components/WelcomeSection';

export function DashboardPage(): JSX.Element {
  return (
    <div className="flex flex-col w-full min-h-screen max-w-screen-l mt-4 mx-auto">
      <Header>Welcome to BC Experience</Header>
      <WelcomeSection />
      <BlockersSection />
    </div>
  );
}
